class LiveChatService {
  constructor() {
    this.listeners = [];
    this.pendingState = null;
  }
  openLiveAgent() {
    this.emitStatusChange(true);
  }
  liveAgentClosed() {
    this.emitStatusChange(false);
  }
  onLiveChatStateChange(callback) {
    if (this.pendingState !== null) {
      callback(this.pendingState);
    }
    this.listeners.push(callback);
    return () => {
      this.listeners.splice(this.listeners.indexOf(callback), 1);
    };
  }
  emitStatusChange(isOpen) {
    if (this.listeners.length === 0) {
      this.pendingState = isOpen;
    }
    this.listeners.forEach((callback) => {
      callback(isOpen);
    });
  }
}
const liveChatService = new LiveChatService();

export { liveChatService };
